var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRocket(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "rocket (1) 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M33.5802 2.69122C33.5521 2.56465 33.4537 2.46622 33.3341 2.43106C29.2138 1.42559 19.7005 5.01153 14.5466 10.1654C13.6255 11.0795 12.7888 12.0709 12.0435 13.1256C10.4544 12.985 8.86538 13.1045 7.50835 13.6951C3.68335 15.3756 2.57241 19.7701 2.25601 21.6545C2.19273 22.0201 2.43882 22.3717 2.81148 22.435C2.87476 22.442 2.93804 22.449 3.00132 22.442L9.1396 21.767C9.14663 22.2311 9.17476 22.6951 9.22398 23.1522C9.2521 23.4686 9.39976 23.7709 9.62476 23.9959L12.0013 26.3654C12.2263 26.5904 12.5287 26.7381 12.8451 26.7662C13.3021 26.8154 13.7591 26.8436 14.2232 26.8506L13.5482 32.9818C13.506 33.3545 13.7802 33.692 14.1529 33.7272C14.2162 33.7342 14.2794 33.7342 14.3357 33.7201C16.2201 33.4178 20.6216 32.3068 22.2951 28.4818C22.8857 27.1248 23.0052 25.5428 22.8716 23.9607C23.9334 23.2154 24.9248 22.3717 25.8388 21.4576C31.0068 16.3178 34.5716 7.01543 33.5802 2.69122ZM25.4451 15.3193C24.1302 16.6342 21.9927 16.6412 20.6779 15.3193C19.356 14.0045 19.356 11.867 20.6779 10.5451C21.9927 9.22325 24.1302 9.22325 25.4521 10.5451C26.7669 11.867 26.7669 14.0045 25.4451 15.3193Z",
    fill: "#2EBB49"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M11.8406 28.08C11.4539 28.4667 10.8352 28.6144 10.0898 28.748C8.41641 29.0292 6.93984 27.5878 7.24219 25.9003C7.35469 25.2605 7.69922 24.3605 7.91016 24.1495C8.02969 24.03 8.03672 23.8331 7.91719 23.7136C7.84687 23.6433 7.75547 23.6081 7.65703 23.6222C6.72187 23.7347 5.85 24.1636 5.18906 24.8245C3.52969 26.4839 3.375 32.6222 3.375 32.6222C3.375 32.6222 9.52031 32.4675 11.1727 30.8081C11.8406 30.1402 12.2625 29.2753 12.375 28.3331C12.4031 28.0449 12.0445 27.8691 11.8406 28.08Z",
    fill: "#2EBB49"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRocket);
export default __webpack_public_path__ + "static/media/rocket.f8b5af8712ca966f50c63836abb67e1b.svg";
export { ForwardRef as ReactComponent };